export default __webpack_public_path__ + "static/213-75b1ee86478b2159be1eb39a39ef8785.gif";